const loadingTypes = {
  SET_LOADING: "SET_LOADING",
  RESET_LOADING: "RESET_LOADING",
  SET_QUOTE_LOADING: "SET_QUOTE_LOADING",
};

export default loadingTypes;
